import {useI18n} from 'i18n/I18nContext'
import EventPage from 'organization/Event/EventPage'
import {EventFaqHelp} from 'organization/Event/Help/FAQ'
import {ZapierActions} from 'organization/Event/Integrations/Zapier/ZapierActions'
import {ZapierApiToken} from 'organization/Event/Integrations/Zapier/ZapierApiToken'
import {ZapierGuide} from 'organization/Event/Integrations/Zapier/ZapierGuide'
import {useOrganizationEvent} from 'organization/Event/OrganizationEventProvider'
import BreadcrumMenu from 'organization/theme/Breadcrum'
import React from 'react'

export const Zapier = () => {
  const {event} = useOrganizationEvent()
  const {t} = useI18n()

  return (
    <EventPage>
      <>
        <div className="row pl-30 pb-30 pr-30">
          <BreadcrumMenu
            title="Zapier"
            helpInfo={<EventFaqHelp faqKey="zapierIntegration" />}
          />

          <div className="create__event-area mb-20 col-12">
            <div className="body__card-wrapper attendant__wrapper">
              <h3>Zapier</h3>
              <b>
                {t('orgZapier.statusLabel')}{' '}
                <span style={{color: 'green'}}>
                  {t('orgZapier.statusActive')}
                </span>{' '}
              </b>
              <ZapierApiToken token={event?.connection_token ?? ''} />
              <ZapierGuide />
            </div>
          </div>

          <div className="create__event-area mb-20 col-12">
            <div className="body__card-wrapper attendant__wrapper">
              <div className="row">
                <h3>{t('orgZapier.availableActionsTitle')}</h3>
                <p>{t('orgZapier.availableActionsHint')}</p>
              </div>

              <ZapierActions />
            </div>
          </div>
        </div>
      </>
    </EventPage>
  )
}
